<template>
  <section class="editor-entities">
    <h1>Modèles de données</h1>

    <el-row :gutter="10">
      <el-col :xs="12" :md="12" :lg="6" v-for="entity in entities" :key="entity.entityId">
        <div class="entity box">
          <h3><i class="el-icon-tickets"></i> {{ entity.name }}</h3>
          <div v-for="field in entity.fields" :key="field.name">
            <u>{{ field.label }} :</u> <br>
            {{ field.name }}
            <span v-for="type in field.type" :key="type">{{ type }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'admin-entities',
  components: {
  },
  data() {
    return {
      entities: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.entities = await api.getEntities(this.$route.params.spaceId);
    },
  },
};
</script>

<style lang="sass">
.editor-entities
  .box
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    margin: 0.3rem 0
    padding: 2rem 1rem
    width: 100%
    background: #ffffff
    border-radius: 10px
    transition: all ease-in 0.2s
    &:hover
      background: lighten(#001861, 75%)
    & ~ .box
      margin-left: 1rem

  .entity
    div
      margin: 0 0 0.4rem 0
      width: 100%
      text-align: left

    img
      display: block
      margin: 0 1rem 1.5rem
      height: 150px
    span
      font-weight: bold

</style>
